import { useEffect, useRef } from 'react';
/**
 * Ref-based version, determining whether component has initialized, meaning
 * performed its first render.
 */
export const useInit = () => {
    const isInitRef = useRef(false);
    useEffect(() => {
        isInitRef.current = true;
    }, []);
    return () => isInitRef.current;
};
//# sourceMappingURL=useInit.js.map